//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import comDialogForm from "@/0/components/comForm/comEditControls/comEditLinkedDropDownList/comDialogForm";

export default {
  props: ["controlItem"],
  components: {
    "dialog-form": comDialogForm
  },
  data() {
    return {
      ThisControlName: "",
      ThisControlValue: null,
      ThisControlValueList: null,
    };
  },
  created() {
    
  },

  methods: {
    onPickerClick() {
      console.log("onPickerClick");
      this.$refs.comDialogForm.initForm(this.controlItem);
      this.$refs.comDialogForm.Show();
    },

    onConfirmClick(finalControlItem) {
      console.log("onConfirmClick==finalControlItem",finalControlItem);
      this.ThisControlName = finalControlItem.ControlName;
      this.ThisControlValue = finalControlItem.ControlValue;
      this.ThisControlValueList = finalControlItem.ControlValueList;

      console.log("controlItem",this.controlItem);
      
      this.controlItem.ControlValueList = finalControlItem.ControlValueList;
    },

    onHelpIconClick($event){
      console.log("OnHelpIconClick-$event",$event);
      if(this.controlItem && this.controlItem.HelperText){
        this.$msg.toast(this.controlItem.HelperText);
      }else{
        this.$msg.toast("没有找到帮助信息");
      }
    },

  }
};
